require('./sendN1PasswordStep1.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @ utils
const { FormattedText } = require('core/i18n').i18n;

// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { PrinterPreviewManager } = require('components/contactCenter/printer/printerPreviewManager');
const PrinterPreviewManagerButton = require('components/contactCenter/printer/printerPreviewManagerButton');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');

class SendN1PasswordStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    handleCancelClick(){
        this.props.history.push('/myprofile/global');
    }

    isReady() {
        return this.props.immProfileFields.get('isFetching');
    }

    handleFinish() {
        this.props.onConfirm();
    }

    buildFooterButtons() {
        const textLeftButton = <FormattedText value="sendN1PasswordStep1-cancelButton" />;
        const textRightButton = <FormattedText value="sendN1PasswordStep1-confirmBtn" />;

        return (
            <div className="sendn1-cc-step1__buttons">
                <div className="sendn1-cc-step1__left-button">
                    <OKButton modifier="additional-action-secondary" size="small" onClick={this.handleCancelClick}>{textLeftButton}</OKButton>
                </div>
                <div className="sendn1-cc-step1__right-button">
                    <PrinterPreviewManagerButton
                        size={'small'}
                        modifier={'primary'}
                        onClick={this.handleFinish}
                    >
                        {textRightButton}
                    </PrinterPreviewManagerButton>
                </div>
            </div>
        );
    }

    render() {
        const { address, username } = this.props
        const title = <FormattedText value="sendN1PasswordStep1-title" />;
        const confirmIdNote = <FormattedText value="sendN1PasswordStep1-confirmIdNote" />;
        const addressHeader = <FormattedText value="sendN1PasswordStep1-addressHeader" />;
        const claveN1Header = <FormattedText value="sendN1PasswordStep1-claveN1Header" />;
        const claveN1Subtext = <FormattedText value="sendN1PasswordStep1-claveN1Subtext" />;
        const confirmUsername = <FormattedText value="sendN1PasswordStep1-confirmUsername" />;
        const confirmAdd2 = <FormattedText value="sendN1PasswordStep1-confirmAdd2" />;
        const confirmUsername2 = <FormattedText value="sendN1PasswordStep1-confirmUsername2" />;
        const buttons = this.buildFooterButtons();

        const acceptText = <FormattedText value="wizard-redirectConfirmationAcceptButton" />;
        const cancelText = <FormattedText value="wizard-redirectConfirmationCancelButton" />;
        const confirmationTitle = <FormattedText value="wizard-redirectConfirmationTitle" />;
        const confirmationMessage = <FormattedText value="wizard-redirectConfirmationMessage" />;

        return (
            <section className="sendn1-cc-step1" id="printable-wizard">
                <h4 className="sendn1-cc-step1__title">
                    {title}
                </h4>
                <div className="sendn1-cc-step1__row-info no-print-out">
                    <BlockInfo extraClass="sendn1-cc-step1__medium-box">
                        {confirmIdNote}
                    </BlockInfo>
                    <div className="sendn1-cc-step1__address">
                        <p className="sendn1-cc-step1__address-header">{addressHeader}</p>
                        <span className="sendn1-cc-step1__address-text">{address}</span>
                    </div>
                </div>
                <div className="sendn1-cc-step1__header">
                    <h4 className="sendn1-cc-step1__title no-print-out">
                        {claveN1Header}
                    </h4>
                    <p className="sendn1-cc-step1__sub-title-text no-print-out">{claveN1Subtext}</p>
                </div>
                <BlockInfo extraClass="sendn1-cc-step1__large-box">
                    <p>{confirmUsername}<span>{username}</span>,</p>
                    <p>{confirmAdd2}
                        <span className="sendn1-cc-step1__address-string">{' ' + address}</span>
                    </p>
                    <p>{confirmUsername2}<span>{username}</span>?</p>
                </BlockInfo>
                <PrinterPreviewManager />
                <div className="sendn1-cc-step1__footer no-print-out">
                    {buttons}
                </div>
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={this.isReady}
                />
            </section>
        );
    }
}

SendN1PasswordStep1.propTypes = {
    address: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object,
};

module.exports = withRouter(SendN1PasswordStep1);
